import React, { useState, useEffect } from "react";
import { Box, useTheme, InputBase, IconButton, Button } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import SearchIcon from "@mui/icons-material/Search";
import {  getStockV } from "../../services/reporteStock.services";
import { getOneStockTejido, getStockTejidoStock, updateEstadoSalida } from "../../services/stockTejido.services";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ModalEditInventario from "../../modal/stock/modalEntrada-Salida"; // Importar el modal de vista previa
import QRCode from 'qrcode';
import ModalPreview from "../../modal/modalPreview"; // Importar el modal de vista previa
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getStockTejidoEspera } from "../../services/stockTejido.services";
import { getStock2TejidoStock } from "../../services/stockTejido.services";
import ModalConfirmacion from "../../modal/stockTejido/modalBaja";


const RolloGeneral = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [productos, setProductos] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [registro, setRegistro] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [previewData, setPreviewData] = useState(""); // Estado para guardar los datos de vista previa
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [printerInfo, setPrinterInfo] = useState(''); // Estado para guardar la información de la impresora
  const [errorMessage, setErrorMessage] = useState(''); 

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


   const filterData = (searchText, start, end) => {
    if (!Array.isArray(data)) return [];

    // Convertir fechas a objetos Date para comparación
    const startD = start ? new Date(start + "T00:00:00") : null;
    const endD = end ? new Date(new Date(end + "T00:00:00").getTime() + 86400000) : null;


    return data.filter(item => {
      // Filtrado texto
      const matchText =
        item.id.toString().includes(searchText) ||
        item.cod.toLowerCase().includes(searchText.toLowerCase()) ||
        item.serie.toLowerCase().includes(searchText.toLowerCase()) ||
      (item.maquina_descripcion && item.maquina_descripcion.toLowerCase().includes(searchText.toLowerCase()));


      if (!matchText) return false;

      // Filtrado fechas
      if (startD || endD) {
        const itemDate = new Date(item.create_at);
        if (startD && itemDate < startD) return false;
        if (endD && itemDate > endD) return false;
      }

      return true;
    });
  };

    useEffect(() => {
    const filtered = filterData(searchValue, startDate, endDate);
    setFilteredData(filtered);
  }, [searchValue, startDate, endDate, data]);

  

  // Obtener datos de la vista al cargar el componente
  const fetchPrueba = async () => {
    try {
      const response = await  getStock2TejidoStock();
      setData(response);
      setFilteredData(response);
    } catch (error) {
      console.error("Error al obtener los datos del backend:", error);
    }
  };

  useEffect(() => {
    fetchPrueba();
  }, []);

const exportarExcel = () => {
  const dataExportar = filteredData.length > 0 ? filteredData : productos;

  // Mapear datos con formato deseado
  const dataFormateada = dataExportar.map((item) => ({
    Serie: item.serie,
    Codigo: item.cod,
    Producto: item.producto_descripcion,
    Cantidad: item.cantidad,
    Cliente: item.cliente,
    Alto: `${item.alto} m`, // unidad "m"
    Largo: item.largo,
    Peso: item.peso,
    Fecha: formatDate(item.create_at),
    Máquina: item.maquina_descripcion,
    Operador: item.operador,
    Observación: item.obs,
    "Metro Cuadrado": item.mcuadrado,
    "Metro Cuadrado Total": item.mcuadradototal,
  }));

  // Agregamos resumen al final
  const totalRollos = dataFormateada.length;
  const totalM2 = dataFormateada.reduce((acc, curr) => acc + (curr["Metro Cuadrado Total"] || 0), 0);
  dataFormateada.push({});
  dataFormateada.push({
    Serie: "Resumen",
    Producto: `Cantidad de rollos: ${totalRollos}`,
    Cliente: `Total m²: ${totalM2.toFixed(2)}`
  });

  const worksheet = XLSX.utils.json_to_sheet(dataFormateada);

  // Ajustar ancho de columnas automáticamente
  const maxColWidths = Object.keys(dataFormateada[0]).map((key) => {
    const maxLength = Math.max(
      ...dataFormateada.map((row) => (row[key] ? row[key].toString().length : 0)),
      key.length
    );
    return { wch: maxLength + 5 }; // +5 para espacio
  });
  worksheet["!cols"] = maxColWidths;

  // Estilos: negrita y fondo para headers
  const headerKeys = Object.keys(dataFormateada[0]);
  headerKeys.forEach((key, index) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: index }); // primera fila
    if (!worksheet[cellRef]) return;
    worksheet[cellRef].s = {
      fill: {
        fgColor: { rgb: "D9E1F2" }, // color celeste
      },
      font: {
        bold: true,
        color: { rgb: "000000" },
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
    };
  });

  // Crear libro y exportar
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Tejidos");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true,
  });
  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });
  saveAs(blob, "historial_rollos.xlsx");
};

  const handleRowClick = (params) => {
    // setRegistro(params.row); // Guarda el registro seleccionado
    setOpen(true); // Abre el modal
  };

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    if (Array.isArray(data)) {
      const filtered = data.filter(
        (item) =>
          item.id.toString().includes(value) ||
          item.cod.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };


  // const handleMenuClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleSubMenuClick = (event) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubMenuAnchorEl(null);
  };

  const handleDarSalida = () => {
    if (!selectedRow || !selectedRow.id) {
      toast.error("No hay fila seleccionada.");
      return;
    }
    setOpenConfirm(true); // ✅ solo abre el modal
  };


  const handleEtiqueta = async () => {
    const { serie } = selectedRow;
  
    try {
      const response = await getOneStockTejido(serie);
 
      if (!response || typeof response !== "object") {
        console.error("Respuesta inesperada de getOneDatos:", response);
        return;
      }
  
      // Generar la etiqueta para el objeto response
      const fecha = new Date(response.create_at).toLocaleDateString("es-ES");
      const qrImageUrl = await QRCode.toDataURL(response.serie, { errorCorrectionLevel: 'H' }).catch(error => {
        console.error('Error generando el QR:', error);
        return null; // Retorna null en caso de error
      });
  
      const etiqueta = `
        
        ^XA
        ^PON
        ^PW800
        ^LL400

        ^FO2150,950^A0N,40,30^FD${response.serie}^FS

        ^FO50,100^A0N,35,35^FDMedidas:^FS
        ^FO50,450^A0N,55,25^FD${response.alto}x${response.largo}^FS

        ^FO1500,100^A0N,35,35^FDPeso:^FS
        ^FO1500,450^A0N,55,25^FD${response.peso} kg^FS

        ^FO2000,50^BQN,2,8^FDQA,${qrImageUrl}^FS
        ^FO50,850^A0N,40,35^FD${response.cod}^FS
        ^FO50,1150^A0N,25,25^FD${response.maquina_descripcion}^FS

        ^XZ
`;
      setPreviewData(etiqueta); // Guardar los datos en el estado de vista previa
      handleMenuClose();
    } catch (error) {
      console.error("Error en handleEtiqueta:", error);
    }
  };
  
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

  const columns = [
    // {
    //   field: "menu",
    //   headerName: "",
    //   flex: 0.2,
    //   renderCell: (params) => (
    //     <IconButton onClick={(event) => handleMenuClick(event, params.row)}>
    //       <MenuIcon />
    //     </IconButton>
    //   ),
    // },
    { field: "id", headerName: "ID", flex: 0.4 },
    { field: "serie", headerName: "Serie", flex: 0.5 },
    { field: "cod", headerName: "Codigo", flex: 0.5 },
    { field: "producto_descripcion", headerName: "Producto", flex: 3 ,cellClassName: "name-column--cell"},
    { type: "number", field: "cantidad", headerName: "Cantidad", flex: 0.5},
    { 
      field: "mcuadrado", 
      headerName: "m²", 
      flex: 0.5,
      valueFormatter: (params) => `${params.value} m²`
    },
    { 
      field: "mcuadradototal", 
      headerName: "m²_total", 
      flex: 0.5,
      valueFormatter: (params) => `${params.value} m²`
    },
    { 
      field: "peso", 
      headerName: "peso", 
      flex: 0.5,
      valueFormatter: (params) => `${params.value} kg`
    },
    { field: "maquina_descripcion", headerName: "Máquina", flex: 0.8 },
    {
      field: "create_at",
      headerName: "Fecha",
      flex: 1,
      valueGetter: (params) => formatDate(params.row.create_at),
    },
    { field: "obs", headerName: "Observacion", flex: 1.5 },
  ];

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    fetchPrueba();
    handleMenuClose();
  }

  const handleClosePreview = () => {
    setPreviewData(""); // Limpiar los datos de vista previa al cerrar el modal
  };

  
  const handleEntrada = async () => {
    setOpenModal(true);
    setRegistro("entrada");
  };

  const handleSalida = async () => {
    setOpenModal(true);
    setRegistro("salida");
  };

  
const formatText = (text, maxLength) => {
  const words = text.split(" ");
  let lines = [];
  let currentLine = "";

  words.forEach((word) => {
    if ((currentLine + word).length > maxLength) {
      lines.push(currentLine);
      currentLine = word;
    } else {
      currentLine += (currentLine ? " " : "") + word;
    }
  });

  if (currentLine) lines.push(currentLine);
  return lines;
};


  const handlePrint = async () => {
    if (!selectedRow || !selectedRow.id) {
      setErrorMessage('No se ha seleccionado ninguna fila.');
      return;
    }
    const { serie } = selectedRow;
  
    try {
      const response = await getOneStockTejido(serie);

      // Si response no es un array, conviértelo en uno
      const items = Array.isArray(response) ? response : [response];

      const etiquetas = await Promise.all(
        items.map(async (item) => {
          // const descripcionLines = formatText(item.descripcion, 40);

          const fecha = new Date(item.create_at).toLocaleDateString("es-ES");

const descripcionLines = formatText(item.descripcion, 40); // o 40 según el tamaño de letra

function generarBloqueDescripcion(startY, x, fontSizeY = 28, fontSizeX = 28, lineSpacing = 40) {
  return descripcionLines.map((line, index) => {
    const y = startY - (index * lineSpacing);
    return `^FO${y},${x}^A0R,${fontSizeY},${fontSizeX}^FD${line}^FS`;
  }).join('\n');
}
const bloqueDescripcion1 = generarBloqueDescripcion(300, 50);
const bloqueDescripcion2 = generarBloqueDescripcion(300, 800);
const bloqueDescripcion3 = generarBloqueDescripcion(300, 1600);


let zpl = `
    ^XA
^POI
^PW820
^LL2420

^FO700,50^A0R,30,30^FDNumero de Serie:${item.cod_interno}^FS
^FO650,50^A0R,25,30^FD${fecha}^FS

^FO580,50^A0R,30,30^FDCant. Chapa:^FS
^FO520,90^A0R,30,30^FD${item.cantidad}^FS

^FO580,300^A0R,30,30^FDUtilizable:^FS
^FO520,330^A0R,30,30^FD${item.cantidad_entrada}^FS

^FO420,50^A0R,25,30^FDFABRICA:${item.serie}^FS
^FO370,50^A0R,30,30^FD${item.cod}^FS

${bloqueDescripcion1}


^FO500,500^BQN,2,8^FDQA,${item.cod_interno}^FS
^FO100,740^GB700,3,3,B,0^FS

^FO700,800^A0R,30,30^FDNumero de Serie:${item.cod_interno}^FS
^FO650,830^A0R,25,30^FD${fecha}^FS

^FO580,800^A0R,30,30^FDCant. Chapa:^FS
^FO520,850^A0R,30,30^FD${item.cantidad}^FS

^FO580,1080^A0R,30,30^FDUtilizable:^FS
^FO520,1110^A0R,30,30^FD${item.cantidad_entrada}^FS

^FO420,800^A0R,25,30^FDFABRICA:${item.serie}^FS
^FO370,800^A0R,30,30^FD${item.cod}^FS

${bloqueDescripcion2}

^FO500,1350^BQN,2,8^FDQA,${item.cod_interno}^FS
^FO100,1550^GB700,3,3,B,0^FS

^FO700,1600^A0R,30,30^FDNumero de Serie:${item.cod_interno}^FS
^FO650,1630^A0R,25,30^FD${fecha}^FS

^FO580,1600^A0R,30,30^FDCant. Chapa:^FS
^FO520,1650^A0R,30,30^FD${item.cantidad}^FS

^FO580,1880^A0R,30,30^FDUtilizable:^FS
^FO520,1910^A0R,30,30^FD${item.cantidad_entrada}^FS

^FO420,1600^A0R,25,30^FDFABRICA:${item.serie}^FS
^FO370,1600^A0R,30,30^FD${item.cod}^FS
${bloqueDescripcion3}
^FO500,2150^BQN,2,8^FDQA,${item.cod_interno}^FS

^XZ
`;



          return zpl;
        })
      );

      if (window.BrowserPrint) {
        // Asegúrate de que BrowserPrint está disponible
        window.BrowserPrint.getDefaultDevice(
          "printer",
          (device) => {
            if (device) {
              setPrinterInfo(
                `Dispositivo predeterminado encontrado: ${device.name}`
              );
              let zplCommand = etiquetas.join("\n");

              device.send(
                zplCommand,
                function (response) {
                  console.log("Datos enviados exitosamente:", response);
                },
                function (error) {
                  console.error("Error al enviar datos:", error);
                }
              );
            } else {
              setPrinterInfo(
                "No hay una impresora predeterminada configurada."
              );
            }
          },
          (error) => {
            setErrorMessage(
              `Error al obtener el dispositivo predeterminado: ${error}`
            );
          }
        );
      } else {
        setErrorMessage("BrowserPrint no está disponible.");
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setErrorMessage("Error al obtener los datos.");
    }
  
    handleMenuClose();
  };


  const handlePrint5cm = async () => {
    if (!selectedRow || !selectedRow.id) {
      setErrorMessage('No se ha seleccionado ninguna fila.');
      return;
    }
    const { id, serie } = selectedRow;
  
    try {
      const response = await getOneStockTejido(serie);
  const items = Array.isArray(response) ? response : [response];
      const etiquetas = await Promise.all(items.map(async (item) => {
        const fecha = new Date(item.create_at).toLocaleDateString("es-ES");
        let zpl = `
          
            ^XA
            ^PON
            ^PW800
            ^LL400

            ^FO520,280^A0N,40,30^FD${response.serie}^FS

            ^FO50,50^A0N,35,35^FDMedidas^FS
            ^FO50,120^A0N,55,25^FD${response.alto}x${response.largo}^FS

            ^FO300,50^A0N,35,35^FDPeso^FS
            ^FO300,120^A0N,55,25^FD${response.peso} kg^FS

            ^FO500,50^BQN,2,8^FDQA,${response.serie}^FS
            ^FO50,220^A0N,40,35^FD${response.cod}^FS
            ^FO50,320^A0N,35,35^FD${response.maquina_descripcion}^FS

            ^XZ

        `;
  
        return zpl;
  
      }));
      if (window.BrowserPrint) { // Asegúrate de que BrowserPrint está disponible
        window.BrowserPrint.getDefaultDevice("printer",
          (device) => {
            if (device) {
              setPrinterInfo(`Dispositivo predeterminado encontrado: ${device.name}`);
              let zplCommand = etiquetas.join("\n");
  
              device.send(zplCommand, function(response) {
                console.log("Datos enviados exitosamente:", response);
              }, function(error) {
                console.error("Error al enviar datos:", error);
              });
            } else {
              setPrinterInfo("No hay una impresora predeterminada configurada.");
            }
          },
          (error) => {
            setErrorMessage(`Error al obtener el dispositivo predeterminado: ${error}`);
          }
        );
      } else {
        setErrorMessage('BrowserPrint no está disponible.');
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setErrorMessage('Error al obtener los datos.');
    }
  
    handleMenuClose();
  };

  const contarRollos = () => {
    return filteredData.length;
  };

const calcularMetrosCuadrados = () => {
  return filteredData.reduce((acc, curr) => {
    const valor = parseFloat(curr.mcuadrado || curr.m2 || 0);
    return acc + (isNaN(valor) ? 0 : valor);
  }, 0).toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' m²';
};



  //const calcularCantidad = () => {
  //  return filteredData.reduce((acc, curr) => acc + curr.cantidad_entrada, 0);
  //};
  
 // const calcularCantidadm = () => {
  //  const total = filteredData.reduce((acc, curr) => acc + parseFloat(curr.m2 || 0), 0);
   // return total.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m²';
  //};

  //useEffect(() => {
   // calcularCantidadm();
    //calcularCantidad();
  
 // }, [filteredData]);
  
const handleExportExcel = () => {
  if (!filteredData || filteredData.length === 0) {
    toast.error(
      `No hay datos para exportar`,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
    return;
  }

  // Aplicar el filtro manualmente aquí:
  const datosFiltradosParaExportar = filteredData.filter(item => item.cantidad_entrada > 0);

  if (datosFiltradosParaExportar.length === 0) {
    toast.error(
      `El producto no tiene cantidad disponible para exportar`,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
    return;
  }

  const exportData = datosFiltradosParaExportar.map((item) => ({
    id: item.id,
    cod: item.cod,
    descripcion: item.producto_descripcion,
    serie: item.serie,
    cod: item.cod,
    cod_interno: item.cod_interno,
    cantidad: item.cantidad,
    cantidad_entrada: item.cantidad_entrada,
    m2: item.m2 ? `${item.m2} m²` : "",
    caballete: item.caballete,
    create_at: item.create_at ? formatDate(item.create_at) : "",
    obs: item.obs,
  }));

  const ws = XLSX.utils.json_to_sheet(exportData);

  ws["!cols"] = [
    { wch: 6 },
    { wch: 20 },
    { wch: 20 },
    { wch: 25 },
    { wch: 20 },
    { wch: 18 },
    { wch: 18 },
    { wch: 10 },
    { wch: 20 },
    { wch: 18 },
    { wch: 30 },
  ];

  // Nombre archivo (puedes ajustarlo según tu lógica)
  const productosUnicos = [...new Set(datosFiltradosParaExportar.map((item) => item.cod))];
  let nombreArchivo = "reporte_stock.xlsx";
  if (productosUnicos.length === 1) {
    nombreArchivo = `stock_${productosUnicos[0]}.xlsx`;
  } else if (productosUnicos.length === 2) {
    nombreArchivo = `stock_de_${productosUnicos[0]} y ${productosUnicos[1]}.xlsx`;
  } else if (productosUnicos.length > 2) {
    nombreArchivo = `stock_varios_productos.xlsx`;
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Stock");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(dataBlob, nombreArchivo);
};



  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" p={0}>
        <Header
          title="Rollos"
          subtitle="En Stock"
        />
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              marginRight: "2%",
              marginLeft: "2%",
            }}
          >
            {/*<Button
              sx={{
                background: "#143f04",
                width: "100%",
                height: "3rem!important",
                color: "white",
                borderRadius: "8px",
                "&:hover": {
                  background: "#36a60f", // Color de fondo cuando el botón está en hover
                },
              }}
              onClick={handleExportExcel}
              variant="contained"
              color="primary"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
                alt="Excel Icon"
                style={{ width: 24, height: 24, marginRight: 8 }}
              />
              Exportar
            </Button>*/}
          </Box>
          <Box sx={{ ml: 2, display: "flex", flexDirection: "column" }}>
          {/* Inputs de fecha */}
         <Box display="flex" gap={2} mb={1} sx={{ maxWidth: 400 }}>
            <InputBase
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              placeholder="Fecha inicio"
              sx={{
                backgroundColor: colors.primary[400],
                borderRadius: "4px",
                padding: "6px 12px",
                color: "white",
                width: "100%",
              }}
            />
            <InputBase
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              placeholder="Fecha fin"
              sx={{
                backgroundColor: colors.primary[400],
                borderRadius: "4px",
                padding: "6px 12px",
                color: "white",
                width: "100%",
              }}
            />
          </Box>
          </Box>
          <Box display="flex" gap={2} mb={1} marginLeft={"10px"}>
          <Button
            sx={{
              background: "#143f04",
              width: "100%",
              height: "3rem!important",
              color: "white",
              borderRadius: "8px",
              "&:hover": {
                background: "#36a60f", // Color al hacer hover
              },
            }}
            onClick={exportarExcel}
            variant="contained"
            color="primary"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
              alt="Excel Icon"
              style={{ width: 24, height: 24, marginRight: 8 }}
            />
            Exportar
          </Button>

          </Box>

          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            height={"40%"}
            width={"90%"}
            ml={1}
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Buscar"
              value={searchValue}
              onChange={handleSearchChange}
            />
            <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
      
     
 

      <Box display="flex" justifyContent="end" p={0} sx={{ ml: 2, marginBottom: "-3vh" }}>
          <Box sx={{ 
            marginRight: "1vh",
            fontSize: "20px",
            color:"rgb(206, 220, 0)",
          }}>
            Cantidad Rollos:
              
          </Box>
          <Box sx={{ 
             color:"rgb(255, 255, 255)",
             fontSize: "20px",
             
           }}>
                {contarRollos()}
          </Box>



          <Box sx={{ 
            marginLeft: "3vh",
            marginRight: "1vh",
            fontSize: "20px",
            color:"rgb(206, 220, 0)",
          }}>
          Cantidad m² total:
          </Box>
          <Box sx={{ 
             color:"rgb(255, 255, 255)",
             fontSize: "20px",
              marginRight: "1.8vh"
           }}>
                {calcularMetrosCuadrados()}
          </Box>

      </Box>
      <Box
        m="40px 0 0 0"
        height="80vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={filteredData}
          columns={columns}
          onRowClick={handleRowClick} // Abrir modal al hacer doble clic
          components={{ Toolbar: GridToolbar }}
          getRowId={(row) => row.id}
        />
      </Box>
      {/*<Box>*/}
      {/*<Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >*/}
        {/* <MenuItem onClick={handleEntrada}>Entrada Inventario</MenuItem> */}
        {/*<MenuItem onClick={handlePrint5cm}>Imprimir(Etiqueta5cm)</MenuItem>*/}
        {/* <MenuItem onClick={handlePrint}>Imprimir(Etiqueta30cm)</MenuItem> */}
        {/* <MenuItem onClick={handleSalida}>Salida Inventario</MenuItem> */}
        {/*<MenuItem onClick={handleEtiqueta}>Visualizar</MenuItem>
        <MenuItem onClick={handleDarSalida}>Dar salida</MenuItem>*/}

      {/*</Menu>*/}
      
      {/*</Box>*/}

      {/* <ModalEditInventario
        open={openModal}
        onClose={handleCloseModal}
        onSelectClient={selectedRow} // Mostrar los datos recibidos
        registro={registro}
      /> */}
          <ModalConfirmacion
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        mensaje="¿Estás seguro que deseas dar salida al producto?"
        onConfirm={async (obs) => {
          if (!selectedRow || !selectedRow.serie) {
            toast.error("No hay fila seleccionada.");
            return;
          }
      
          try {
            const dataObs = {
              obs:obs
            }
            // Asegúrate de que tu servicio acepte el segundo parámetro (observación)
            await updateEstadoSalida(selectedRow.serie, dataObs); 
            toast.success("Producto dado de salida correctamente");
      
            fetchPrueba(); // Refresca la tabla
          } catch (error) {
            console.error("Error al dar salida:", error);
            toast.error("Error al dar salida al producto.");
          } finally {
            setOpenConfirm(false);
          }
        }}
      />

      {previewData && (
        <ModalPreview
          open={Boolean(previewData)}
          onClose={handleClosePreview}
          data={previewData}
        />
      )}
    </Box>
  );
};

export default RolloGeneral;
